import React from 'react';
import {defineMessages} from 'react-intl';
import {LocalizedText} from '@igp/shared/components/i18n';
import {ActionConfirmationModal} from '@igp/shared/components/modal';

const localized = defineMessages({
    title: {
        id: 'UnlinkAgentConfirmationModal_title',
        defaultMessage: 'Unlink Agent',
    },
    confirmButtonLabel: {
        id: 'UnlinkAgentConfirmationModal_confirmButtonLabel',
        defaultMessage: 'Unlink Agent',
    },
    cancelButtonLabel: {
        id: 'UnlinkAgentConfirmationModal_cancelButtonLabel',
        defaultMessage: 'Cancel',
    },
    prompt: {
        id: 'UnlinkAgentConfirmationModal_prompt',
        defaultMessage: 'Are you sure you want to unlink {username} (ID: {uid})?',
    },
    effectListTitle: {
        id: 'UnlinkAgentConfirmationModal_effectListTitle',
        defaultMessage: 'This will:',
    },
    listItem1: {
        id: 'UnlinkAgentConfirmationModal_listItem1',
        defaultMessage: 'Remove their agent identity and convert to regular player',
    },
    listItem2: {
        id: 'UnlinkAgentConfirmationModal_listItem2',
        defaultMessage: 'Release the Agent ID for reassignment',
    },
    listItem3: {
        id: 'UnlinkAgentConfirmationModal_listItem3',
        defaultMessage: 'Recalculate agent hierarchy for all downstream agents',
    },
    listItem4: {
        id: 'UnlinkAgentConfirmationModal_listItem4',
        defaultMessage: 'Stop all future revenue share calculations',
    },
    listItem5: {
        id: 'UnlinkAgentConfirmationModal_listItem5',
        defaultMessage: 'Update debt responsibility assignments',
    },
    irreversible: {
        id: 'UnlinkAgentConfirmationModal_irreversible',
        defaultMessage: 'This action cannot be undone.',
    },
});

type UnlinkAgentConfirmationModalProps = {
    username: string;
    uid: string;
    onCancel: () => void;
    onConfirm: () => void;
};

export function UnlinkAgentConfirmationModal({username, uid, onCancel, onConfirm}: UnlinkAgentConfirmationModalProps) {
    return (
        <ActionConfirmationModal
            title={localized.title}
            confirmButtonLabel={localized.confirmButtonLabel}
            cancelButtonLabel={localized.cancelButtonLabel}
            confirmButtonColor="error"
            contentDescription={
                <>
                    <LocalizedText label={localized.prompt} labelParams={{username, uid}} />
                    <div>
                        <LocalizedText label={localized.effectListTitle} />
                    </div>
                    <ul>
                        <li>
                            <LocalizedText label={localized.listItem1} />
                        </li>
                        <li>
                            <LocalizedText label={localized.listItem2} />
                        </li>
                        <li>
                            <LocalizedText label={localized.listItem3} />
                        </li>
                        <li>
                            <LocalizedText label={localized.listItem4} />
                        </li>
                        <li>
                            <LocalizedText label={localized.listItem5} />
                        </li>
                    </ul>
                    <strong>
                        <LocalizedText label={localized.irreversible} />
                    </strong>
                </>
            }
            handleCancel={onCancel}
            handleConfirm={onConfirm}
        />
    );
}
